var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.i18nLoaded)?_c('div',{staticClass:"default"},[_c('div',{staticClass:"logo-wrapper"},[_c('LogoWithTitle')],1),_c('section',{staticClass:"section"},[_c('h1',[_vm._t("title")],2),_vm._t("contents")],2),_c('Footer')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }